var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.widget ? _c('div', {
    staticClass: "widget-form-container"
  }, [_c('div', {
    staticClass: "section-container"
  }, [_c('substrate-mount', [_c('div', {
    staticClass: "input-container"
  }, [_c('input-price', {
    attrs: {
      "input-id": "widget.minDisplayAmount",
      "input-name": "".concat(_vm.$t('showing.minimum.cost'), ", ").concat(_vm.currency.sign),
      "min-value": 0,
      "currency": _vm.currency
    },
    on: {
      "change": function change($event) {
        _vm.widget.minDisplayAmount = $event;
      }
    },
    model: {
      value: _vm.widget.minDisplayAmount,
      callback: function callback($$v) {
        _vm.$set(_vm.widget, "minDisplayAmount", $$v);
      },
      expression: "widget.minDisplayAmount"
    }
  })], 1), _c('div', {
    staticClass: "input-container"
  }, [_c('input-price', {
    attrs: {
      "input-id": "widget.premiumDisplayAmount",
      "input-name": "".concat(_vm.$t('premium.messages'), ", ").concat(_vm.currency.sign),
      "min-value": 0,
      "error": !_vm.isValid,
      "currency": _vm.currency
    },
    on: {
      "change": function change($event) {
        _vm.widget.premiumDisplayAmount = $event;
      }
    },
    model: {
      value: _vm.widget.premiumDisplayAmount,
      callback: function callback($$v) {
        _vm.$set(_vm.widget, "premiumDisplayAmount", $$v);
      },
      expression: "widget.premiumDisplayAmount"
    }
  })], 1)])], 1), _c('div', {
    staticClass: "button-primary-container"
  }, [_c('cs-button', {
    attrs: {
      "width": _vm.buttonWidth,
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.proceed')) + " ")])], 1)]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }